<div class="status-item">
	<div class="logo">
		<img [src]="img" alt="platform logo" />
	</div>

	@if(online !== null) {
	<div class="status-chip">
		<div class="status-icon" [class.offline]="!online">
			<mat-icon>{{ online ? 'check' : 'close' }}</mat-icon>
		</div>
		<span class="status-span"
			>{{ (online ? 'common.online' : 'common.offline') | translate }}</span
		>
	</div>
	}
</div>
